import React from 'react';

export const SourceTypeDate = (props: { size: number } = { size: 24 }) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="new-Icon/source_date"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="source_date">
        <rect
          id="bck-SorceDataType"
          fill="#575757"
          x="0"
          y="0"
          width="32"
          height="32"
          rx="2"
        ></rect>
        <path
          d="M9.024,23.1893333 L9.024,8 L12.2453333,8 C13.4968951,8 14.446219,8.34132992 15.0933333,9.024 C15.7404477,9.70667008 16.064,10.6737715 16.064,11.9253333 L16.064,19.0293333 C16.064,20.4515627 15.7191146,21.5004411 15.0293333,22.176 C14.3395521,22.8515589 13.347562,23.1893333 12.0533333,23.1893333 L9.024,23.1893333 Z M11.2,10.048 L11.2,21.1413333 L12.2026667,21.1413333 C12.8142253,21.1413333 13.2479987,20.988446 13.504,20.6826667 C13.7600013,20.3768874 13.888,19.8968922 13.888,19.2426667 L13.888,11.9253333 C13.888,11.327997 13.7671123,10.8657794 13.5253333,10.5386667 C13.2835543,10.2115539 12.8426699,10.048 12.2026667,10.048 L11.2,10.048 Z M19.5413333,23.1893333 L19.5413333,10.048 L17.024,10.048 L17.024,8 L24.2346667,8 L24.2346667,10.048 L21.7173333,10.048 L21.7173333,23.1893333 L19.5413333,23.1893333 Z"
          id="DT"
          fill="#FFFFFF"
        ></path>
      </g>
    </g>
  </svg>
);
